import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { applyUi, preventIosInputZoom, resolveTheme } from '@onepos/ui';
import './fonts';
import '@onepos/ui/tokens.css';
import '@onepos/ui/layout.css';
import './app.css';
import { Spinner } from '@onepos/ui';
import { Root } from './kassa/KassaApp';
import { isSupportMode } from './lib/api';
import { lazyNamed } from './lib/lazy';
import { initInstallPrompt } from './lib/install';

// Boshqaruv paneli va ONE POS yordami — alohida bo'laklar (Q-073): kassa va oshxona ekrani ularni yuklamaydi
const App = lazyNamed(() => import('./App'), 'App');
const SupportRoot = lazyNamed(() => import('./pages/SupportPage'), 'SupportRoot');

// Boshlang'ich ko'rinish (telefonga qarab); restoran va xodim tanlovi kirgach qo'llanadi (Q-031)
applyUi({ theme: resolveTheme('auto', 'system'), accent: 'amber' });
// iPhone: yozish maydoniga bosilganda sahifa o'zi kattalashib qolmasin (Q-040)
preventIosInputZoom();
// "Ilovani o'rnatish" — brauzer ruxsatini sahifa ochilishidayoq ushlab qolamiz
initInstallPrompt();

// Internetsiz ochilish (public/sw.js). Faqat production build'da — dev serverda kesh xalaqit beradi.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}

const root = document.getElementById('root');
if (!root) throw new Error('root elementi topilmadi');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <Suspense fallback={<Spinner />}>
        {isSupportMode() ? <SupportRoot /> : <Root panel={<App />} />}
      </Suspense>
    </BrowserRouter>
  </StrictMode>,
);
